<template>
  <v-app>
    <Loader v-if="showSpinner" />

    <Snackbar />

    <LayoutTopBar />

    <v-main>
      <v-navigation-drawer 
        v-if="$route.name === 'login' || $route.name === 'registration' || $route.name === 'forgetPassword' || $route.name === 'resetPassword'"
        stateless 
        permanent 
        floating 
        fixed 
        left
        color="transparent" 
        :width="'140px'"
        class="pa-1 pb-10 pl-4 languages-menu"
      >
        <!-- <MenuGuides class="pb-10"/> -->
        <!-- <LocaleSelector
          v-if="$route.name === 'login' || $route.name === 'registration' || $route.name === 'forgetPassword' || $route.name === 'resetPassword'"
          class="pb-10"
        /> -->
      </v-navigation-drawer>

      <v-navigation-drawer
        v-if="loggedIn"
        :mini-variant="resizeDrawer"
        absolute
        permanent
        fixed
        :width="isUserAdmin ? '5%' : '14%'"
      >

        <!-- Logged as ADMIN -->
        <v-list
          v-if="loggedIn && isUserAdmin"
          nav
          dense
        >
          <v-list-item-group
            active-class="deep-blue--text text--accent-4"
          >
            <MenuItem
              v-for="link in loggedAdminLinks"
              :key="`${link.label}-header-link`" 
              :link="link"
            />

            <MenuItemLogout />

            <MenuItemSetupGuide />

          </v-list-item-group>
        </v-list>

        <!-- Logged as CUSTOMER -->
        <v-list
          v-else-if="loggedIn && !isUserAdmin"
          nav
          dense
        >

          <v-list-item-group
            active-class="deep-blue--text text--accent-4"
          >
            <!-- Removed component because I18N cannot update data insede array -->
            <!-- <MenuItem
              v-for="link in loggedCustomerLinks"
              :key="`${link.label}-header-link`" 
              :link="link"
            /> -->
            <v-list-item
              :key="`${$t('menu.customer.accounts')}-header-link`" 
              to="/customerAccount"
              class="px-1 py-2"
            >
              <span>
                <v-tooltip 
                  :open-delay="tooltipDelay"
                  right 
                  max-width="200px"
                  :key="`${$t('menu.customer.accounts')}-header-link`" 
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="d-flex">
                      <v-list-item-icon class="mr-5">
                        <v-icon large color="green darken-2">home</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title class="d-flex justify-start">
                        <div class="list-item">{{ $t('menu.customer.accounts') }}</div>
                      </v-list-item-title>
                    </span>
                  </template>
                  <span>{{ $t('menu.customer.accountsTooltip') }}</span>
                </v-tooltip>
              </span>
            </v-list-item>

            <v-list-item
              :key="`${$t('menu.customer.dashboard')}-header-link`" 
              to="/customerReports"
              class="px-1 py-2"
            >
              <span>
                <v-tooltip 
                  :open-delay="tooltipDelay"
                  right 
                  max-width="200px"
                  :key="`${$t('menu.customer.dashboard')}-header-link`" 
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="d-flex">
                      <v-list-item-icon class="mr-5">
                        <v-icon large color="purple darken-2">analytics</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title class="d-flex justify-start">
                        <div class="list-item">{{ $t('menu.customer.dashboard') }}</div>
                      </v-list-item-title>
                    </span>
                  </template>
                  <span>{{ $t('menu.customer.dashboardTooltip') }}</span>
                </v-tooltip>
              </span>
            </v-list-item>

            <v-list-item
              :key="`${$t('menu.customer.settings')}-header-link`" 
              to="/customerSettings"
              class="px-1 py-2"
            >
              <span>
                <v-tooltip 
                  :open-delay="tooltipDelay"
                  right 
                  max-width="200px"
                  :key="`${$t('menu.customer.settings')}-header-link`" 
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="d-flex">
                      <v-list-item-icon class="mr-5">
                        <v-icon large color="blue darken-2">settings</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title class="d-flex justify-start">
                        <div class="list-item">{{ $t('menu.customer.settings') }}</div>
                      </v-list-item-title>
                    </span>
                  </template>
                  <span>{{ $t('menu.customer.settingsTooltip') }}</span>
                </v-tooltip>
              </span>
            </v-list-item>

            <MenuItemLinkTranscript v-if="isLinkTranscriptEnabled" />

            <MenuItemLogout />

            <MenuItemSetupGuide />

          </v-list-item-group>
        </v-list>

        <!-- <MenuGuides
          v-if="loggedIn && isUserAdmin"
          buttonClass="mt-12"
        /> -->

      </v-navigation-drawer>

      <LoginPanel v-if="$route.name === 'login' && !$vuetify.breakpoint.mobile" />
    
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <LayoutFooter />
  </v-app>
</template>

<script>
  // import Vue from "vue";
  import { authComputed } from './store/helpers.js'
  // import { loggedAdminLinks, loggedCustomerLinks } from './utils/menuLinks.js'
  import { mapState, mapGetters } from 'vuex'
  import i18n from './i18n';

  export default {
    components: { 
      Loader: () => import('./components/Loader'),
      Snackbar: () => import('@/components/Snackbar'), 
      MenuItem: () => import('@/components/LayoutMenuItem'), 
      MenuItemLogout: () => import('@/components/LayoutMenuItemLogout'), 
      MenuItemSetupGuide: () => import('@/components/LayoutMenuItemSetupGuide'), 
      MenuItemLinkTranscript: () => import('@/components/LayoutMenuItemLinkTranscript'), 
      LoginPanel: () => import('@/components/LayoutLoginPanel'), 
      LayoutTopBar: require('@/components/LayoutTopBar').default,
      LayoutFooter: require('@/components/LayoutFooter').default,
      // LocaleSelector: () => import('@/components/LocaleSelector'), 
      // MenuGuides: () => import('@/components/MenuGuides'), 
    },
    data: () => ({
      isLoading: false,
      drawer: {
        expandOnHover: false,
      },
      isLinkTranscriptEnabled: false,
      loggedAdminLinks: [
        {
          label: 'Accounts',
          // label: i18n.t('menu.admin.accounts'),
          url: '/accounts',
          icon: 'home',
          color: 'green darken-2',
          tooltip: 'List of the Approved Accounts'
          // tooltip: i18n.t('menu.admin.accountsTooltip')
        },
        {
          label: 'Requests',
          // label: i18n.t('menu.admin.requests'),
          url: '/requests',
          icon: 'rule_folder',
          color: 'red darken-2',
          tooltip: 'List of the Pending Request'
          // tooltip: i18n.t('menu.admin.requestsTooltip')
        },
        {
          label: 'Dashboard',
          // label: i18n.t('menu.admin.dashboard'),
          url: '/adminReports',
          icon: 'analytics',
          color: 'purple darken-2',
          tooltip: 'Reports Dashboard'
          // tooltip: i18n.t('menu.admin.dashboardTooltip')
        },
        {
          label: 'Admin Users',
          url: '/adminusers',
          icon: 'mdi-account-group',
          color: 'green darken-2',
          tooltip: 'CRM Connect Admin Users'
        },
        {
          label: 'Settings',
          // label: i18n.t('menu.admin.settings'),
          url: '/adminSettings',
          icon: 'mdi-account',
          color: 'blue darken-2',
          tooltip: 'Profile'
          // tooltip: i18n.t('menu.admin.settingsTooltip')
        }
      ],
      // loggedCustomerLinks: [
      //   {
      //     label: i18n.t('menu.customer.accounts'),
      //     url: '/customerAccount',
      //     icon: 'home',
      //     color: 'green darken-2',
      //     tooltip: i18n.t('menu.customer.accountsTooltip')
      //   },
      //   {
      //     label: i18n.t('menu.customer.dashboard'),
      //     url: '/customerReports',
      //     icon: 'analytics',
      //     color: 'purple darken-2',
      //     tooltip: i18n.t('menu.customer.dashboardTooltip')
      //   },
      //   {
      //     label: i18n.t('menu.customer.settings'),
      //     url: '/customerSettings',
      //     icon: 'settings',
      //     color: 'blue darken-2',
      //     tooltip: i18n.t('menu.customer.settingsTooltip')
          
      //   }
      // ],
      offset: true,
    }),
    watch:{
      $route (to, from){ 
        // console.log(`[APP] watch - route...`);
        // console.log(`[APP] watch - route - to: `, to);
        // console.log(`[APP] watch - route - from: `, from);

        if(to.name !== 'login') this.checkLinks();
      }
    }, 
    computed: {
      ...authComputed,
      ...mapState('users', ['showSpinner']),
      ...mapGetters({
        tooltipDelay: 'users/getTooltipDelay'
      }),
      resizeDrawer () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return true;
          case 'sm': return true
          case 'md': return false
          case 'lg': return false
          case 'xl': return false
          default: return false
        }
      }
    },
    methods: {
      checkLinks() {
        const loggedIn = this.loggedIn;
        // console.log(`[APP] - checkLinks - loggedIn: ${loggedIn}`);

        const isUserAdmin = this.isUserAdmin;
        // console.log(`[APP] - checkLinks - isUserAdmin: ${isUserAdmin}`);

        // expandOnHover is set as TRUE when logged as admin
        this.drawer.expandOnHover = isUserAdmin ? true : false

        if(loggedIn && !isUserAdmin) {
          // get Customer wconfig 
          const wconfig = this.getCustomerWconfig;
          // console.log(`[APP] - checkLinks - wconfig: ${JSON.stringify(wconfig)}`);

          if (wconfig){
            // get entities
            const entities = wconfig.entities;

            // Link Transcript menu item object
            const linkTranscriptOption = {
              // label: 'Link Transcripts',
              label: i18n.t('menu.customer.linkTranscript'),
              url: '/customerLinkTranscripts',
              icon: 'assignment',
              color: 'black darken-2',
              // tooltip: 'Manage the required keys to be used in the Link Transcript feature'
              tooltip: i18n.t('menu.customer.linkTranscriptTooltip'),
            };  

            // let linkTranscriptIsEnabled = false;
            // this.isLinkTranscriptEnabled = false;
              
            for (const item of Object.entries(entities)) {
              // console.log(`[APP] - checkLinks - item: `, item)
              // console.log(`[APP] - checkLinks - item[1]: `, item[1])

              // MS Dynamics object
              if (!item[1].disable 
                && item[1].linkTranscript){
                this.isLinkTranscriptEnabled = true
                break;
              }
              // Zendesk Ticket object
              else if (!item[1].disable 
                && item[1].attachTranscript 
                && item[1].attachTranscript.link )
              {
                this.isLinkTranscriptEnabled = true
                break;
              } 
              // Zendesk EndUSer object
              else if (!item[1].disable 
                && item[1].endUserTicket 
                && item[1].endUserTicket.attachTranscript 
                && item[1].endUserTicket.attachTranscript.link )
              {
                this.isLinkTranscriptEnabled = true
                break;
              } 
              else {
                this.isLinkTranscriptEnabled = false
              }
            }
            // console.log('[APP] - checkLinks - this.isLinkTranscriptEnabled: ', this.isLinkTranscriptEnabled)

            // if(this.isLinkTranscriptEnabled) {
            //   const linkIsThere = this.loggedCustomerLinks.filter((eachObj) => eachObj.label === linkTranscriptOption.label);
            //   console.log(`[APP] - checkLinks - linkIsThere: `, linkIsThere);

            //   if(linkIsThere.length === 0) {
            //     this.loggedCustomerLinks.push(linkTranscriptOption);
            //   }
            // } else {
            //   // remove the Link Transcript item from menu
            //   console.log(`[APP] - checkLinks - linkTranscript is DISABLED`);
            //   this.loggedCustomerLinks = this.loggedCustomerLinks.filter((eachObj) => eachObj.label !== linkTranscriptOption.label);
            // }
          }
        }
      }
    },
    created() {
      console.log(`[APP] - created... `);

      // this.loggedAdminLinks = [ ...loggedAdminLinks ]
      // this.loggedCustomerLinks = [ ...loggedCustomerLinks ]

      // LinkTranscript item on menu: control Dynamically based on the state change
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        // console.log(`[APP] - Created - vuex.subscribe - mutation: `, mutation);
        // console.log(`[APP] - Created - vuex.subscribe - state: `, state);

        if (mutation.type === 'users/SET_USER_CONFIGITEMS') {
          // console.log(`Updating to mutation.type: `, mutation.type);
          this.checkLinks()
        }
        if (mutation.type === 'users/SET_USER_DATA') {
          // console.log(`Updating to mutation.type: `, mutation.type);
          this.checkLinks()
        }
      });
    },
    beforeDestroy() {
      // Vuex watch unsubscription
      this.unsubscribe();
    }
  };
</script>

<style lang="scss">
  html { overflow-y: auto }
  
  #app {
    font-family: $body-font-family;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    // background-color: #f5f5f5;
    background-color: #ffffff;

    .v-application,
    .title,
    .headline { // To pin point specific classes of some components
      font-family: $body-font-family, sans-serif !important;
    }

    .headline { // To pin point specific classes of some components
      font-size: 20px !important;
    }

    
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  .list-item {
    font-size: 16px;
  }

  .languages-menu > .v-navigation-drawer__content {
    display: flex; /* or inline-flex */
    flex-flow: row nowrap; /* is default: columns along the main-axis (row) and no wrapping to next lines */
    align-items: flex-end; /* bottom */
    padding-bottom: 50px;
  }
  // body {
  //   font-family: $body-font-family;
  // }

  // .v-application {
  //    font-family: $body-font-family, sans-serif !important;
  //     .title { // To pin point specific classes of some components
  //        font-family: $body-font-family, sans-serif !important;
  //     }
  //  }
</style>

